/**
 * Created by phatbass on 1/29/16.
 */

angular.module('dekky.forms.hideShowPassword', [])
	.service('hideShowPassword', function () {
		var inputType = 'password';

		this.get = function () {
			return inputType;
		};

		this.button = function () {
			if (inputType == 'password') {
				inputType = 'text';
			} else {
				inputType = 'password';
			}
		}
	});